import CreateQuestion from '../components/CreateQuestion';
import QuestionEditorHeader from '../components/QuestionEditorHeader';
import { useEffect, useState } from 'react';
import CKEditor from '../../../../src/components/CKEditor';
import CreateAnswerOption from '../components/CreateAnswerOption';
import AddQuestionProperties from '../components/AddQuestionProperties';
import { useMyContentContext } from '../utils/myContentContext';
import { useParams } from 'react-router';
import { useGetQuestionMutation } from '../../../features/authentication/qSetApiSlice';

const AddMcFillInQuestion = () => {
  const {questionId, courseId} = useParams();
  const [activeStep, setActiveStep] = useState(1);
  const [getTQuestion] = useGetQuestionMutation();
  const { 
    hint, 
    setHint,
    reason,
    setReason, 
    setQuestion,
    setQuestionType,
    setNumChoices,
    setCorrectAnswer,
    setFillInAnswer,
    setFillInAnswerBoxFontSize,
    setFillInAnswerBoxWidth,
    setSelectedAttributeNodes,
    setSelectedTagNodes,
    setSelectedStandardNodes,
    setSelectedTopicNodes,
    dateTimeBasedUniqueKey,
    setDateTimeBasedUniqueKey,
    resetContext,
    setQuestionDocuments,
    setSelectedDocumentIds
  } = useMyContentContext();

  const handleStepClick = (step) => {
    setActiveStep(step);
  };

  useEffect(() => {
    if(questionId)
      getMcFillInQuestionAsync();
    else
      resetContext();
  }, []);

  const getMcFillInQuestionAsync = async ()=>{
    let option = {
      questionId:questionId,
      courseId : courseId
    };
    var response = await getTQuestion(option).unwrap();
    setQuestion(response.question);
    setHint(response.hint);
    setReason(response.reason);
    setQuestionType(response.qType);
    setNumChoices(response.numChoices);
    setCorrectAnswer(response.mcAnswer);
    setFillInAnswer(response.fillInAnswer);
    setFillInAnswerBoxFontSize(response.fillInAnswerFontSize);
    setFillInAnswerBoxWidth(response.fillAnswerWidth);
    setSelectedTagNodes(response.properties.tags);
    setSelectedAttributeNodes(response.properties.attributes);
    setSelectedStandardNodes(response.properties.standards);
    toIdNameModel(response.properties.topics);
    setQuestionDocuments(response.resources);
    setSelectedDocumentIds(response.resources.map((item)=>item.documentId));
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const toIdNameModel = (topics)=>{
    const topicArray = topics.map(({ value, name }) => ({
      id: value,
      name
    }));
    setSelectedTopicNodes(topicArray);
  };
  
  return (
    <div key={dateTimeBasedUniqueKey}>
      <div className='bg-white mb-4 rounded-4'>
        <QuestionEditorHeader
          activeStep={activeStep}
          setpOnClick={handleStepClick}
          setActiveStep={setActiveStep}
          isCRQuestion={false} />
      </div>
      <div className={activeStep == 1 ? '':'d-none'}>
        <CreateQuestion 
          isCRQuestion={false}/>
      </div>
      <div className={`bg-white mb-4 rounded-4 p-4 ${activeStep == 2 ? '' : 'd-none'}`}>
        <CKEditor
          editorData={hint}
          setEditorData={setHint}
        />
      </div>
      <div className={`bg-white mb-4 rounded-4 p-4 ${activeStep == 3 ? '' : 'd-none'}`}>
        <CKEditor
          editorData={reason}
          setEditorData={setReason}
        />
      </div>
      {activeStep == 4 &&
        <CreateAnswerOption />}
      {activeStep == 5 &&
        <AddQuestionProperties />}
    </div>
  );
};

export default AddMcFillInQuestion;
